import {
  Button,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionPanel,
  Spinner,
  Label,
  Dropdown,
  Option,
} from "@fluentui/react-components";
import * as React from "react";
import { useContext, useEffect } from "react";
import { Constants } from "../../common/constants";
import { PolarionAuthenticationProps } from "../../types/CommonTypes";
import { PolarionTeamsContext } from "../PolarionTeamsContext";
import config from "../../config/config";
import { logger } from "../../Logger";

// This is the dialog used to login from Teams to Teamcenter
const PolarionAuthentication: React.FC<PolarionAuthenticationProps> = ({
  teamsContext,
  error,
  checkingOnboardedStatus,
  isOnboarded,
  siteOptions,
  selectedSite,
  onboardedStatusFailed,
  setSelectedSite,
  isSiteOptionsLoaded,
  setIsAuthenticated,
  setOpen,
  seti18n,
}) => {
  //const tcTeamsContext = useContext(TCTeamsFxContext);
  const polarionTeamsContext = useContext(PolarionTeamsContext);
  const { setError } = polarionTeamsContext.failure;
  if (error) {
    setError(error);
  }
  const i18n = polarionTeamsContext.i18n;

  useEffect(() => {
    setIsAuthenticated(polarionTeamsContext?.polarion.isAuthenticated);
  }, [polarionTeamsContext?.polarion.isAuthenticated]);

  useEffect(() => {
    seti18n(polarionTeamsContext.i18n);
  }, [polarionTeamsContext.i18n]);

  // Launch the login process
  const onLoginHandler = async () => {
    logger.logTrace("PolarionAuthentication - onLoginHandler called");
    //Before login then clear local cache if exists.
    window.localStorage.removeItem(Constants.cacheTeamcenterCode);
    window.localStorage.removeItem(Constants.cacheConfiguration);
    window.localStorage.removeItem(Constants.cacheUserConfiguration);
    setOpen(false);
    if (selectedSite) {
      window.localStorage.setItem(
        Constants.cacheSelectedSite,
        JSON.stringify(selectedSite)
      );
    }
    await polarionTeamsContext?.polarion.login();
    logger.logTrace("PolarionAuthentication - onLoginHandler completed");
  };

  return (
    <>
      <div className="text-center">
        {!checkingOnboardedStatus && isOnboarded && (
          <div>
            <div className="login-popup">{i18n.GetStartedTextForPolarion}</div>
            <div className="div-button-dropdown-label">
              {siteOptions?.length > 1 && (
                <div className="div-label-dropdown">
                  <Label className="label-for-dropdown">
                    {i18n.SelectAnEnvironment}:
                  </Label>
                  <Dropdown
                    placeholder=""
                    value={
                      selectedSite?.siteDisplay ||
                      siteOptions[0]?.siteDisplay ||
                      ""
                    }
                    className="dropdown-for-environment"
                    listbox={{ className: "dropdown-listbox" }}
                    onOptionSelect={(event, data) => {
                      const selectedSite = siteOptions.find(
                        (site) => site.siteId === data.optionValue
                      );
                      setSelectedSite(selectedSite || null);
                    }}
                    disabled={
                      siteOptions.length === 0 ||
                      polarionTeamsContext?.polarion?.isAuthenticating ||
                      false
                    }
                  >
                    {siteOptions.map((option) => (
                      <Option key={option.siteId} value={option.siteId}>
                        {option.siteDisplay}
                      </Option>
                    ))}
                  </Dropdown>
                </div>
              )}
              <Button
                appearance="primary"
                className="login-button-width"
                onClick={onLoginHandler}
                disabled={
                  onboardedStatusFailed ||
                  polarionTeamsContext?.polarion?.isAuthenticating ||
                  false
                }
              >
                {polarionTeamsContext?.polarion?.isAuthenticating && (
                  <div className="flex">
                    <Spinner size="tiny" className="login-button" />
                  </div>
                )}
                {i18n.LoginPolarionText}
              </Button>
            </div>
          </div>
        )}
        {!checkingOnboardedStatus && !isOnboarded && (
          <div>
            <b>{i18n.Teamcenter}</b>
            {i18n.NotOnBoardedText}
            <a
              href="https://support.sw.siemens.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              {i18n.ContactUsText}
            </a>
          </div>
        )}
      </div>
      {config.environment === Constants.development &&
        polarionTeamsContext?.failure?.error && (
          <Accordion collapsible>
            <AccordionItem value="1">
              <AccordionHeader>{i18n.ErrorDetailsText}:</AccordionHeader>
              <AccordionPanel>
                {i18n.CorrelationIDText}:{" "}
                {polarionTeamsContext?.failure?.error?.correlationId}
              </AccordionPanel>
              <AccordionPanel>
                {i18n.ErrorCodeText}:{" "}
                {polarionTeamsContext?.failure?.error?.statusCode}
              </AccordionPanel>
              <AccordionPanel>
                {i18n.ErrorMessageText}:{" "}
                {polarionTeamsContext?.failure?.error?.message}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        )}
    </>
  );
};

export default PolarionAuthentication;
